<template>
  <div class="row create-invoices" v-if="canAdd">
    <div class="card width-100">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12" style="display: flex; justify-content: end;">
            <el-date-picker
              id="completionDatePicker"
              v-model="selectedDueBetween"
              type="daterange"
              unlink-panels
              range-separator="To"
              start-placeholder="Due Date Start"
              end-placeholder="Due Date End"
              :format="constants.DATE.FORMAT.DISPLAY"
              data-vv-name="search"
              :picker-options="datePickerConfig.dateRange"
              style="width: 345px;"
              class="m-right-6">
            </el-date-picker>
            <v-select
              multiple
              v-model="selectedClientIds"
              placeholder="Clients"
              label="label"
              value=value
              :reduce="client => client.value"
              :options="uniqueClients"
              style="min-width: 320px;"
              class="m-right-8">
            </v-select>
            <v-select
              v-model="selectedItemCode"
              placeholder="Item Code"
              label="label"
              value="value"
              :reduce="itemCode => itemCode.value"
              :options="uniqueItemCodes"
              style="width: 150px;"
              class="m-right-8">
            </v-select>
            <v-select
              v-model="selectedProjectType"
              placeholder="Project Type"
              label="label"
              value="value"
              :reduce="projectType => projectType.value"
              :options="uniqueProjectTypes"
              style="width: 160px;"
              class="m-right-8">
            </v-select>
            <button type="button" @click="handlePreviewInvoice" :disabled="noTasksSelected" style="margin-top: 0;" class="btn btn-fill btn-info">
              Preview Invoice(s)
            </button>
            <a @click.prevent="handleShowPreferenceModal" href="#"><img src="static/img/gear-icon.png" class="m-left-12 gear-icon"/></a>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <el-table class="table-striped wrap-whole-words search-tasks-table"
                      :data="sortedTableData"
                      border
                      :key="tableKey"
                      row-key="id"
                      :indent="5"
                      :row-style="assessTaskAndClient"
                      :header-cell-class-name="headerSortClass"
                      @selection-change="handleSelectionChange"
                      :max-height="tableHeight(400)"
                      style="width: 100%">
              <el-table-column
                label="Task"
                class-name="wrap-words"
                :min-width="250">
                <template v-slot="props">
                  <span class="invisible">{{props.row.id}}</span>
                  <a href="#" @click="handleEditTask(props.row.id)">{{ getTaskName(props.row) }}</a>
                </template>
              </el-table-column>
              <el-table-column
                :selectable="selectableTask"
                type="selection"
                align="center"
                width="60">
              </el-table-column>
              <el-table-column v-for="column in filteredTableColumns"
                               :min-width="column.minWidth"
                               :key="column.label"
                               :label="column.label">
                <template v-slot="props">
                  <template v-if="isBigData && column.label !== 'Price'">
                    {{ column.propBigData ? lodash.get(props.row, column.propBigData) : ' - ' }}
                  </template>
                  <component v-else :is="column.component" :data="getColumnData(column, props.row)" />
                </template>
              </el-table-column>
              <el-table-column
                width="1"
                label="">
                <template></template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 pagination-info">
            <p class="category">Showing {{total}} entries</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <img src="static/img/legend-orphaned.png" class="legend-img ml-2"  alt="Orphaned Tasks"/> Orphaned Task
            <img src="static/img/legend-qb-onhold.png" class="legend-img ml-2"  alt="Client On Hold"/> Client On Hold
            <img src="static/img/legend-inactive.png" class="legend-img ml-2"  alt="Inactive Client"/> Inactive Client
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import PButton from 'src/components/UIComponents/Button.vue'
import {
  assembleTableColumnSortProps,
  endOfDay,
  filterAndSortTableColumns,
  getTableHeight,
  notifyError,
  setIndexColumnWidth,
  sortNested,
  tableHeaderSortCssClass,
  taskNameWithOptionalRepeatCountSuffix
} from 'src/utilities/utils'
import lodash from 'lodash'
import _ from 'lodash'
import Constants from 'src/utilities/constants'
import Permissions from 'src/utilities/permissions'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import datePickerConfig from '@/components/UIComponents/DatePicker/datePickerConfig'
import tableColumns from '@/utilities/tableColumns'
import {minFields} from 'src/utilities/validation'
import {OK} from 'http-status-codes'

export default {
  components: {
    PButton,
    vSelect
  },
  computed: {
    ...mapGetters({
      user: 'security/user',
      users: 'users/kvpsForSelect',
      statuses: 'statuses/ptracTask',
      autocompleteClients: 'companies/autocompleteResultsClient',
      autocompleteResults: 'companies/autocompleteResults',
      tableData: 'invoices/create/results',
      taskTemplates: 'tasks/templates/results',
      isBigData: 'invoices/create/isBigData',
      uniqueClients: 'invoices/create/uniqueClients',
      uniqueItemCodes: 'invoices/create/uniqueItemCodes',
      uniqueProjectTypes: 'invoices/create/uniqueProjectTypes'
    }),
    isSelectedDueBetween() {
      return Array.isArray(this.selectedDueBetween) && this.selectedDueBetween.length === 2
    },
    sortedTableData() {
      return this.filteredTableData
      // if (this.isBigData) {
      //   return this.filteredTableData
      // }
      // return this.filteredTableData.sort(sortNested(this.sortedProps))
    },
    filteredTableData() {
      if (!this.isSelectedDueBetween
        && (!this.selectedClientIds || this.selectedClientIds.length === 0)
        && !this.selectedItemCode
        && !this.selectedProjectType)
      {
        return this.tableData
      }

      return this.tableData.filter(task => {
        const dueDateCheck = !this.isSelectedDueBetween || this.isDueDateBetweenMatch(task)
        const clientCheck = (!this.selectedClientIds || this.selectedClientIds.length === 0) || this.isClientMatch(task);
        const itemCodeCheck = !this.selectedItemCode || this.isItemCodeMatch(task);
        const projectTypeCheck = !this.selectedProjectType || this.isProjectTypeMatch(task);

        return dueDateCheck && clientCheck && itemCodeCheck && projectTypeCheck;
      })
    },
    filteredTableColumns() {
      return filterAndSortTableColumns(this.tableColumns, this.user, Constants.USER_PREFERENCE_TYPES.INVOICE_TASKS)
    },
    sortedProps() {
      return assembleTableColumnSortProps(this.filteredTableColumns)
    },
    total() {
      return this.tableData.length
    },
    noTasksSelected() {
      return this.selectedTasks.length === 0
    },
    canAdd() {
      return this.$can('create', Permissions.INVOICES)
    },
    indexColumnWidth() {
      return setIndexColumnWidth(this.tableData.length)
    }
  },
  data() {
    return {
      lodash,
      tableKey: 0,
      datePickerConfig,
      constants: Constants,
      selectedDueBetween: [],
      selectedClientIds: [],
      selectedItemCode: '',
      selectedProjectType: '',
      selectedTasks: [],
      mainSearchFieldErrorText: Constants.MESSAGES.AT_LEAST_ONE_FIELD_REQUIRED,
      otherSearchFieldErrorText: '*',
      vvScopes: ['minFields'],
      tableColumns: tableColumns.CREATE_INVOICES,
      queryFilter: ''
    }
  },
  methods: {
    isDueDateBetweenMatch(task) {
      const dueDate = new Date(task.dueDate) // dueDate is coming in as string from ptrac-api
      return dueDate > this.selectedDueBetween[0] && dueDate < endOfDay(this.selectedDueBetween[1])
    },
    isClientMatch(task) {
      const clientId = _.get(task, 'job.clientId', '')
      return this.selectedClientIds.includes(clientId)
    },
    isItemCodeMatch(task) {
      const qbItemCode = _.get(task, 'fieldValues.qbItemCode', '')
      return qbItemCode.toLowerCase() === this.selectedItemCode.toLowerCase()
    },
    isProjectTypeMatch(task) {
      const projectType = _.get(task, 'project.projectType', '')
      return projectType.toLowerCase() === this.selectedProjectType.toLowerCase()
    },
    getTaskName(task) {
      return taskNameWithOptionalRepeatCountSuffix(task)
    },
    headerSortClass({columnIndex}) {
      return tableHeaderSortCssClass(this.filteredTableColumns, columnIndex, 2)
    },
    getColumnData(column, row) {
      return column.prop ? lodash.get(row, column.prop) : row
    },
    selectableTask(row) {
      // only Invoice Submittal tasks with a price (zero is allowed) and all required Quickbooks fields are selectable
      if (row.name === Constants.TASKS.NAMES.INVOICE_SUBMITTAL) {
        return this.allPriceFieldValuesComplete(row)
      }

      if (row.name === Constants.TASKS.NAMES.INVOICE) {
        if (row.children) {
          const childTaskCount = row.children.length
          let completedChildTasks = 0

          for (const childTask of row.children) {
            if (this.allPriceFieldValuesComplete(childTask)) {
              completedChildTasks++
            }
          }
          return childTaskCount === completedChildTasks
        }
      }

      return false
    },
    allPriceFieldValuesComplete(task) {
      return lodash.get(task, 'fieldValues.price') != null
        && lodash.get(task, 'fieldValues.price') !== ''
        && lodash.get(task, 'fieldValues.qbArAccount')
        && lodash.get(task, 'fieldValues.qbItemCode')
        && lodash.get(task, 'fieldValues.qbClass')
    },
    clearForm() {
      this.$validator.reset()
      this.dueBetween = []
    },
    clearResults() {
      this.$store.commit('invoices/create/resetResults')
      this.clearForm()
    },
    maybeClearAndFetch(task) {
      // if it's an Invoice Submittal, or Invoice, or an invoice line item task, refresh results
      if (task.name === Constants.TASKS.NAMES.INVOICE_SUBMITTAL
        || task.name === Constants.TASKS.NAMES.INVOICE
        || _.get(task, 'fieldValues.price')) {
        this.clearAndFetch()
      }
    },
    clearAndFetch() {
      this.selectedDueBetween = null
      this.selectedClientIds = []
      this.selectedItemCode = null
      this.selectedProjectType = null
      this.clearResults()
      this.fetchPtracResults()
    },
    selectedTasksSubtotal() {
      let subtotal = 0;
      this.selectedTasks.forEach((task) => {
        subtotal += Number(task.fieldValues.price)
      })
      return subtotal
    },
    handlePreviewInvoice() {
      const data = {
        tasks: this.selectedTasks,
        subtotal: this.selectedTasksSubtotal()
      }

      this.$eventHub.$emit('show-modal-1', 'Preview Invoices', data, '95%')
    },
    handleEditTask(taskId) {
      this.$eventHub.$emit('show-modal-2', 'Edit Task', {id: taskId})
    },
    handleSelectionChange(selectedTasks) {
      this.selectedTasks = selectedTasks
    },
    async fetchPtracResults() {
      this.$eventHub.$emit('show-modal-1', 'Invoices Loading', null, '600px')

      const response = await this.$store.dispatch('invoices/create/fetchPtracSearchResults')

      if (OK === response.status) {
        if (response.data.length === 0) {
          this.$eventHub.$emit('show-modal-1', 'No Invoices Found', null, '500px')
          this.$store.commit('invoices/create/resetResults')
        }
        return
      }

      notifyError(this, 'Failed to load Invoice Submittal tasks')
    },
    tableHeight(buffer) {
      return getTableHeight(buffer)
    },
    handleShowPreferenceModal() {
      const payload = {
        title: 'Create Invoices',
        preferenceType: Constants.USER_PREFERENCE_TYPES.INVOICE_TASKS
      }
      this.$eventHub.$emit('show-modal-1', 'Search and Sort Preferences', payload, '900px')
    },
    assessTaskAndClient(props) {
      if (lodash.get(props, 'row.orphaned')) {
        return {backgroundColor: '#fbc658'}
      } else if (lodash.get(props, 'row.job.client.quickBooksPreferences.onHold')) {
        return {backgroundColor: '#ff5733'}
      } else if (!lodash.get(props, 'row.job.client.active')) {
        return {backgroundColor: '#c70039'}
      }
    }
  },
  async beforeCreate() {
    await Promise.all([
      this.$store.cache.dispatch('users/fetchAll'),
      this.$store.cache.dispatch('tasks/templates/fetchAll'),
      this.$store.cache.dispatch('statuses/fetchByEntityType', 'PtracTask'),
      this.$store.cache.dispatch('priorities/fetchByEntityType', 'PtracTask'),
      this.$store.cache.dispatch('priorities/fetchByEntityType', 'Job'),
      this.$store.cache.dispatch('types/fetchByEntityType', 'Company'),
      this.$store.cache.dispatch('statuses/fetchByEntityType', 'Company'),
      this.$store.cache.dispatch('companies/fetchActiveForAutocomplete')
    ])

    this.$store.commit('invoices/create/resetResults')
  },
  beforeMount() {
    this.$eventHub.$on('taskSaved', this.maybeClearAndFetch)
    this.$eventHub.$on('invoicesSaved', () => this.clearAndFetch())
    this.$eventHub.$on('jobSaved', () => this.clearAndFetch())
    this.$eventHub.$on('companySaved', () => this.clearAndFetch())
  },
  mounted() {
    minFields('invoices')
    if (this.user.claims.sub) {
      this.fetchPtracResults()
    }
    this.$validator.reset()
  },
  beforeDestroy() {
    this.$eventHub.$off('invoicesSaved')
    this.$eventHub.$off('jobSaved')
    this.$eventHub.$off('taskSaved')
    this.$eventHub.$off('companySaved')
  },
  watch: {
    filteredTableColumns: function() {
      this.tableKey++
    },
    dueBetween: {
      handler: function (dueBetween) {
        if (!dueBetween) {
          this.$store.set('invoices/create/query@dueBetween', [])
        }
      }
    },
    selectedTasks: {
      handler: function (selectedTasks) {
        if (selectedTasks.length > 0) {
          this.$validator.reset()
        }
      }
    },
    user: {
      handler: function(user) {
        if (user) {
          // once user data is available, search for all Invoice Submittal tasks with Pending status assigned to the logged in user
          this.fetchPtracResults()
        }
      }
    }
  }
}
</script>
<style scoped>
label {
  display: block;
}

.create-invoices >>> div.cell label.el-checkbox.is-disabled {
  display: none;
}

.gear-icon {
  width: 26px;
  height: 26px;
  margin-top: 5px;
}
</style>
